<template>

  <div>

    <transition name="fade">
      <div class="hit-form-group" v-bind:key="badgeKey">
        <hit_badge  :survey="survey" :design="getDesign().design" />
      </div>
    </transition>

    <div class="hit-text-left hit-form-group" v-if="$store.getters.user.username">
      <div class="hit-text-right"><a href="#" :style="{'color': survey.badge.text, 'background-color': survey.badge.bg }" class="hit-btn hit-btn-xs hit-btn-default hit-btn-block" v-on:click.prevent="function(){ colorOpen = !colorOpen; }"><hit_icon  :id="'cogwheel'" /> {{ $tc("message.badge", 1) }}</a></div>

    </div>

      <transition name="fade">
        <div v-if="colorOpen" v-bind:key="colorOpen" class="hit-panel hit-panel-default">
          <div class="hit-panel-body">

            <div class="hit-text-center hit-form-group" v-if="$store.getters.user.username">
              <div class="hit-pull-right">
                <a href="#" v-on:click.prevent="getChangeDesign('next')" class="hit-btn hit-btn-xs hit-btn-default"><hit_icon :id="'arrow-right'" /></a>
              </div>
              <div class="hit-pull-left">
              <a href="#" v-on:click.prevent="getChangeDesign('prev')" class="hit-btn hit-btn-xs hit-btn-default"><hit_icon :id="'arrow-left'" /></a>
              </div>
              <div class="hit-btn hit-btn-xs" style="cursor: default;">{{ $tc("message.badge", 1) }} <span class="hit-html-strong">{{ id+1 }}/{{ Object.keys(boards).length }}</span></div>
              <div class="hit-clearfix" />
            </div>

            <div  class="hit-text-center hit-form-group">
              <label class="hit-html-label" v-html="$t('message.text_color')"/>
              <hit_color :id="'col2'" :color="survey.badge.text" :callback="function(col){ setCol({text: col}); }" />
              <label class="hit-html-label" v-html="$t('message.background_color')"/>
              <hit_color :id="'col2'" :color="survey.badge.bg" :callback="function(col){ setCol({bg: col}); }" />
              <label class="hit-html-label" v-html="$t('message.accent_color')"/>
              <hit_color :id="'col1'" :color="survey.badge.accent" :callback="function(col){ setCol({accent: col}); }" />
              <label class="hit-html-label" v-html="$t('message.accent_color')+'2'"/>
              <hit_color :id="'col2'" :color="survey.badge.pluscolor" :callback="function(col){ setCol({pluscolor: col}); }" />
            </div>

          </div>
        </div>
      </transition>

  </div>

</template>

<script>

export default{

  props: {survey: Object, callback: Function},

  data () {
    return {
      badgeKey: new Date().getTime(),
      id: 0,
      boards: this.$store.getters.badges,
      colorOpen: false
    }
  },

  methods: {

    setCol (obj) {
      this.survey.badge = Object.assign(this.survey.badge, obj)
      this.badgeKey = new Date().getTime()

      console.log(this.survey.badge)

      this.callback(JSON.stringify(this.survey.badge))
    },

    getChangeDesign (direction) {
      var badges = this.boards

      var id = 0

      Object.keys(badges).forEach(function (val, index) {
        if (val == this.getDesign().design) {
          this.id = index
          return false
        }
      }.bind(this))

      if (direction == 'prev') {
        this.id = this.id - 1

        if (this.id < 0) { this.id = (Object.keys(badges).length - 1) }
      }
      if (direction == 'next') {
        this.id = this.id + 1

        if (this.id == Object.keys(badges).length) { this.id = 0 }
      }

      this.survey.badge.design = Object.keys(badges)[this.id]

      this.callback(JSON.stringify(this.survey.badge))

      this.badgeKey = new Date().getTime()
    },

    getDesign () {
      return this.survey.badge
    }
  },

  mounted () {
    this.getChangeDesign(false)
  }

}

</script>
